export const ADMIN_SITE_CONFIG = {
  ADMIN_BASE_URL: process.env.NEXT_PUBLIC_ADMIN_BASE_URL,
}
